import { PURGE } from 'redux-persist'
import { LOAD_CONFIGURATION_FINISHED, SET_INTEGRATOR_SHORTNAME, SET_PROPERTY } from 'store/actions/searchAction'
import { EMAIL_SENT } from 'store/actions/leadgenAction'

const INITIAL_STATE = {
  config: {},
  property: {},
  integratorShortName: ''
}

export default function searchReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case LOAD_CONFIGURATION_FINISHED:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload
        }
      }
    case SET_PROPERTY:
      return {
        ...state,
        property: action.payload
      }
    case PURGE:
      return {
        ...state,
        config: INITIAL_STATE.config
      }
    case EMAIL_SENT:
      return {
        ...state,
        property: INITIAL_STATE.property
      }
    case SET_INTEGRATOR_SHORTNAME:
      return {
        ...state,
        integratorShortName: action.payload
      }
    default:
      return state
  }
}
